import { Input } from '@/components/Input';
import {
    selectPrimaryBusinessUnitNumber,
    setPrimaryBusinessUnitNumber,
} from '@/context/borrower';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'PrimaryBusinessUnitNumber';

export function PrimaryBusinessUnitNumber({
    baseId,
    showErrors,
}: IProps): JSX.Element {
    // ***** Redux *****

    const primaryBusinessUnitNumber = useAppSelector(
        selectPrimaryBusinessUnitNumber
    );
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleChange(value: string | boolean): void {
        if (typeof value === 'boolean') return;
        if (value === primaryBusinessUnitNumber) return;
        dispatch(setPrimaryBusinessUnitNumber(value));
    }

    // ***** Render *****
    return (
        <div data-testid={testId}>
            <Input
                title='Suite/building'
                placeholder='Unit, Flat, etc'
                showErrors={showErrors && !primaryBusinessUnitNumber}
                onChange={handleChange}
                id={`${baseId}-input-unitNumber`}
                value={primaryBusinessUnitNumber ?? ''}
            />
        </div>
    );
}
